import _ from 'lodash';
import moment from 'moment';
import {
  getRequest,
  postRequest,
  deleteRequest,
  patchRequest
} from '../../Common/network-call';
import { INSTANCE_URL } from '../../Common/constant';
import { EVENT_DETAILS } from '../../../actions';

export const FETCH_SCHEDULES_DATA_FULFILLED = 'FETCH_SCHEDULES_DATA_FULFILLED';
export const SELECT_SCHEDULE_DATE = 'SELECT_SCHEDULE_DATE';
export const FETCH_SCHEDULES_TRACKS_DATA = 'FETCH_SCHEDULES_TRACKS_DATA';
export const FETCH_TRACK_SESSIONS_DATA = 'FETCH_TRACK_SESSIONS_DATA';
export const SHOW_SIDEBAR = 'SHOW_SIDEBAR';
export const SHOW_BACK_SCREEN = 'SHOW_BACK_SCREEN';
export const FETCH_SESSION_LIVEQA_DATA = 'FETCH_SESSION_LIVEQA_DATA';
export const OPEN_QA_MODAL = 'OPEN_QA_MODAL';
export const SESSION_POLL_LIST = 'SESSION_POLL_LIST';
export const SESSION_POLL_LIST_MODAL = 'SESSION_POLL_LIST_MODAL';
export const SESSION_POLL_ACTION_MODAL = 'SESSION_POLL_ACTION_MODAL';
export const SESSION_POLL_RESULT = 'SESSION_POLL_RESULT';
export const MY_BOOKED_SCHEDULE = 'MY_BOOKED_SCHEDULE';
export const MY_RATED_SESSION = 'MY_RATED_SESSION';
export const HOLD_THIS_SESSION_DETAILS = 'HOLD_THIS_SESSION_DETAILS';
export const FETCH_LIVEQA_REPLY = 'FETCH_LIVEQA_REPLY';
export const SELECT_SCHEDULE_TRACK = 'SELECT_SCHEDULE_TRACK';
export const SET_SELECTED_SCHEDULE_DETAILS = 'SET_SELECTED_SCHEDULE_DETAILS';
export const SESSION_VIDEO_MODAL_DETAILS = 'SESSION_VIDEO_MODAL_DETAILS';
export const THIS_SESSION_RATING_FORM = 'THIS_SESSION_RATING_FORM';
export const SESSION_POLL_NOT_SUBMITTED = 'SESSION_POLL_NOT_SUBMITTED';
export const SESSION_BY_TAG_FILTERED = 'SESSION_BY_TAG_FILTERED';
export const SESSION_COLORS = 'SESSION_COLORS';

export const fetchScheduleData = (
  session,
  source = 'session',
  selectedDate = null,
  callback
) => {
  var filter = encodeURI(`(eventid=${session.eventid})AND(isactive=1)`);
  var orderby = 'scheduledate%20ASC';
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/scheduledates?include_count=true&filter=(${filter})&order=${orderby}`;
  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        // mutable local scheduledate data
        let local_scheduleDate_data = { data: [], count: data.meta.count };
        _.map(data.resource, date => {
          let local_date_obj = date;

          // Maintaining a flag not to show tracks where selected date has a '##NOTRACK##' track
          local_date_obj.hideTrack = false;

          // Filtering all dates' tracks to find if '##NOTRACK##' is available
          if (date?.ScheduleDateToScheduletracks.length > 0) {
            let noTrackFilter = _.filter(
              date.ScheduleDateToScheduletracks,
              track => track.trackname == '##NOTRACK##'
            );

            if (noTrackFilter.length > 0) {
              local_date_obj.hideTrack = true;
            }
          }

          // Final push to local object
          local_scheduleDate_data.data.push(local_date_obj);
        });

        dispatch({
          type: FETCH_SCHEDULES_DATA_FULFILLED,
          // payload: { data: local_scheduleDate_data, count: data.meta.count }
          payload: local_scheduleDate_data
        });

        if (source !== 'map-details') {
          if (data.meta.count > 0) {
            let today = moment().format('yyyy-MM-DD');

            let filterDataArr = [];
            if (!_.isEmpty(selectedDate)) {
              filterDataArr = _.filter(local_scheduleDate_data.data, scd => {
                return scd?.scheduledateid == selectedDate?.scheduledateid;
              });
            } else {
              filterDataArr = _.filter(local_scheduleDate_data.data, scd => {
                return scd?.scheduledate == today;
              });
            }

            if (filterDataArr.length > 0) {
              dispatch(
                fetchScheduleTracks(
                  session,
                  filterDataArr[0],
                  source,
                  res => {}
                )
              );
              dispatch(selectScheduleDate(filterDataArr[0]));
            } else {
              dispatch(
                fetchScheduleTracks(
                  session,
                  local_scheduleDate_data.data[0],
                  source,
                  res => {}
                )
              );
              dispatch(selectScheduleDate(local_scheduleDate_data.data[0]));
            }
          } else {
            dispatch(fetchScheduleTracks(session, [], source, res => {}));
            dispatch(selectScheduleDate([]));
          }

          // dispatch(
          //   selectScheduleDate(data.resource.length > 0 ? data.resource[0] : [])
          // );
        }
        callback({
          success: 1,
          result: {
            response: local_scheduleDate_data.data,
            count: local_scheduleDate_data.count
          }
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const makeEmpty_ScheduleData = () => {
  return dispatch => {
    dispatch({ type: FETCH_SCHEDULES_DATA_FULFILLED, payload: {} });
  };
};

export const selectScheduleDate = date => {
  // console.log('date: ', date);
  return {
    type: SELECT_SCHEDULE_DATE,
    payload: date
  };
};

export const fetchScheduleTracks = (
  session,
  data,
  source = 'session',
  callback
) => {
  // ----- concats All tab if tracks length > 1
  let dispatchData =
    data?.ScheduleDateToScheduletracks.length > 1 &&
    _.concat(
      [{ trackname: 'All', type: 'fetchAll' }],
      data.ScheduleDateToScheduletracks
    );

  // ----- creates the track id strinig
  let trackIds = '(';
  data?.ScheduleDateToScheduletracks.length > 0 &&
    _.map(data.ScheduleDateToScheduletracks, (track, index) => {
      trackIds = `${trackIds}${track.scheduletrackid}${
        index == data.ScheduleDateToScheduletracks.length - 1 ? ')' : ','
      }`;
    });

  if (source !== 'map-details') {
    return dispatch => {
      dispatch({
        type: FETCH_SCHEDULES_TRACKS_DATA,
        payload: {
          data: data?.ScheduleDateToScheduletracks
            ? data?.ScheduleDateToScheduletracks.length > 1
              ? dispatchData // with all tab concatted
              : data?.ScheduleDateToScheduletracks // w/o
            : [],
          count:
            data?.ScheduleDateToScheduletracks.length > 0
              ? data.ScheduleDateToScheduletracks.length
              : 0
        }
      });

      // ----- selects the track on track nav bar
      data?.ScheduleDateToScheduletracks.length > 0 &&
        dispatch(
          selectScheduleTrack(
            data?.ScheduleDateToScheduletracks.length == 1
              ? data?.ScheduleDateToScheduletracks[0]
              : data?.ScheduleDateToScheduletracks.length > 1
              ? dispatchData[0]
              : {}
          )
        );

      trackIds != '(' &&
        dispatch(
          fetchAllSessionsForDate(session, { trackIds }, res => {
            if (res.success === 0) {
              callback({ success: 0, message: res.message });
            }
          })

          // ----- above code fetches all track for this date, below code for this date's 0th track, code updated on 22/12/22 by Anubhab
          // fetchTrackSessions(
          //   session,
          //   data?.ScheduleDateToScheduletracks.length > 0
          //     ? data?.ScheduleDateToScheduletracks[0]
          //     : {},
          //   res => {
          //     if (res.success === 0) {
          //       callback({ success: 0, message: res.message });
          //     }
          //   }
          // )
        );
    };
  } else {
    return dispatch => {
      dispatch({
        type: FETCH_SCHEDULES_TRACKS_DATA,
        payload: {
          data: data?.ScheduleDateToScheduletracks
            ? data.ScheduleDateToScheduletracks
            : [],
          count:
            data?.ScheduleDateToScheduletracks.length > 0
              ? data.ScheduleDateToScheduletracks.length
              : 0
        }
      });
      callback({ success: 1 });
    };
  }
};

export const selectScheduleTrack = track => {
  return dispatch => {
    dispatch({ type: SELECT_SCHEDULE_TRACK, payload: track });
  };
};

export const makeEmpty_ScheduleTracks = () => {
  return dispatch => {
    dispatch({ type: FETCH_SCHEDULES_TRACKS_DATA, payload: {} });
  };
};

export const fetchAllSessionsForDate = (session, value, callback) => {
  let fetchFilter = encodeURI(
    `((scheduletrackid IN ${value.trackIds})AND(eventid=${session.eventid}))`
  );
  let fetchOrderby = 'starttime%20ASC,sessionid%20ASC';
  let fetchRelated =
    'speaker_by_speakerid,speaker_by_sessionspeakers,interactivemaps_by_interactivemaplocation_session_link,scheduletracks_by_scheduletrackid';
  let fetchUrl = `${INSTANCE_URL}/api/v2/eventify/_table/session?include_count=true&related=${fetchRelated}&order=${fetchOrderby}&filter=${fetchFilter}&caller=ios`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      data => {
        _.map(data.resource, item => {
          if (!_.isEmpty(item.speaker_by_speakerid)) {
            item.speaker_by_sessionspeakers.splice(
              0,
              0,
              item.speaker_by_speakerid
            );
          }
        });
        dispatch({
          type: FETCH_TRACK_SESSIONS_DATA,
          payload: { data: data.resource, count: data.meta.count }
        });
        callback({
          success: 1,
          result: { response: data.resource }
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchTrackSessions = (session, data, callback) => {
  var filter = encodeURI(
    `(scheduletrackid=${data.scheduletrackid})AND(eventid=${session.eventid})`
  );
  var orderby = 'starttime%20ASC,sessionid%20ASC';
  let related =
    'speaker_by_speakerid,speaker_by_sessionspeakers,interactivemaps_by_interactivemaplocation_session_link';
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/session?include_count=true&related=${related}&filter=${filter}&order=${orderby}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        _.map(data.resource, item => {
          if (!_.isEmpty(item.speaker_by_speakerid)) {
            item.speaker_by_sessionspeakers.splice(
              0,
              0,
              item.speaker_by_speakerid
            );
          }
        });
        dispatch({
          type: FETCH_TRACK_SESSIONS_DATA,
          payload: { data: data.resource, count: data.meta.count }
        });
        callback({
          success: 1,
          result: { response: data.resource }
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const makeEmpty_TrackSessions = () => {
  return dispatch => {
    dispatch({ type: FETCH_TRACK_SESSIONS_DATA, payload: {} });
  };
};

export const setSessionDetailsAction = sessDetails => {
  return dispatch => {
    dispatch({ type: SET_SELECTED_SCHEDULE_DETAILS, payload: sessDetails });
  };
};

export const showSidebar = value => {
  return dispatch => {
    dispatch({ type: SHOW_SIDEBAR, payload: value });
  };
};

export const showBackScreen = value => {
  return dispatch => {
    dispatch({ type: SHOW_BACK_SCREEN, payload: value });
  };
};

export const deleteUserRsvpSession = (session, sessId, callback) => {
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(sessionid=${sessId})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/session_rsvp?filter=(${filter})`;

  return dispatch => {
    deleteRequest(
      url,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchRsvpSessionTotalAccess = (session, sessId, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(sessionid=${sessId})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/session_rsvp?include_count=true&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        callback({
          success: 1,
          totalaccess: res.meta.count,
          data: res.resource
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const rsvpSessionAccess = (session, values, callback) => {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/session_rsvp`;
  var body = {
    resource: [{ ...values }]
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response : ', response);
        callback({ success: 1, response: response });
        dispatch();
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchliveqa = (
  session,
  sessionid,
  publishType = '1',
  pageCount = 0,
  callback
) => {
  let perPage = 15;
  let offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;

  let url = `${INSTANCE_URL}/api/v2/liveqa`;
  let postBody = {
    requesttype: 'fetch',
    sessionid: sessionid,
    ispublished: publishType,
    userid: session.userid,
    offset: offset
  };

  return dispatch => {
    postRequest(
      url,
      postBody,
      session,
      dispatch,
      res => {
        // console.log('res: ', res);
        // correct res format
        // totalcount: 4, publishedcount: '1', unpublishedcount: '3', notsubmittedpoll: 0, data: Array(1)
        let obj = {
          totalcount: res.resource.totalcount,
          publishedcount: JSON.parse(res.resource.publishedcount),
          unpublishedcount: JSON.parse(res.resource.unpublishedcount),
          notsubmittedpoll: res.resource.notsubmittedpoll,
          data: res.resource.data
        };
        callback({
          success: 1,
          response: res.resource.result,
          count: res.resource.totalcount
        });
        dispatch({
          type: FETCH_SESSION_LIVEQA_DATA,
          payload: {
            data: res.resource.data,
            count: res.resource.totalcount,
            fetchData: obj
          }
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const clearSessionLiveQa = () => {
  return dispatch => {
    dispatch({
      type: FETCH_SESSION_LIVEQA_DATA,
      payload: {}
    });
  };
};

export const clearLiveQAList = value => {
  return dispatch => {
    dispatch({ type: FETCH_SESSION_LIVEQA_DATA, payload: value });
  };
};

export const openqaModal = value => {
  return dispatch => {
    dispatch({ type: OPEN_QA_MODAL, payload: value });
  };
};

export const addQue_liveqa = (session, resource, callback) => {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa`;
  var body = {
    resource: resource
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response : ', response);
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchLiveQAReply = (session, qaid, callback) => {
  let filter = encodeURI(`(eventid=${session.eventid})AND(qaid=${qaid})`);
  let orderby = encodeURI(`replyid DESC`);
  let limit = 15;
  let offset = 0;
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa_reply?related=appuser_by_replyby&include_count=true&order=${orderby}&limit=${limit}&offset=${offset}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
        let obj = {
          data: res.resource,
          count: res.meta.count
        };
        dispatch({ type: FETCH_LIVEQA_REPLY, payload: obj });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchThisQALikeCount = (session, qaid, callback) => {
  let filter = encodeURI(`(eventid=${session.eventid})AND(qaid=${qaid})`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa_likes?include_count=true&related=appuser_by_likedby&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        let hasLiked = _.filter(res.resource, qalike => {
          return qalike?.likedby == session.userid;
        });

        callback({
          success: 1,
          count: res.resource.length,
          liked: hasLiked.length > 0 ? true : false,
          likeid: hasLiked.length > 0 ? `${hasLiked[0]?.likeid}` : ''
        });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const addQA_reply = (session, resource, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa_reply`;
  let postBody = {
    resource: [{ ...resource }]
  };

  return dispatch => {
    postRequest(
      url,
      postBody,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const clearQA_reply = () => {
  return dispatch => {
    dispatch({ type: FETCH_LIVEQA_REPLY, payload: {} });
  };
};

export const updateAutoPublishLiveQA = (
  session,
  resourceObj,
  eventDetails,
  callback
) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/event`;
  let patchBody = {
    resource: [{ ...resourceObj }]
  };
  let updatedEventDetails = {
    resource: {
      ...eventDetails.resource,
      ['isautopublish_qa']: resourceObj.isautopublish_qa
    }
  };

  return dispatch => {
    patchRequest(
      url,
      patchBody,
      session,
      dispatch,
      res => {
        callback({ success: true });
        dispatch({
          type: EVENT_DETAILS,
          payload: updatedEventDetails
        });
      },
      error => {
        callback({ success: false, message: error });
      }
    );
  };
};

export const liveQALikeDislike = (session, type, values, callback) => {
  switch (type) {
    case 'like':
      let postUrl = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa_likes`;
      let postBody = {
        resource: [{ ...values }]
      };
      return dispatch => {
        postRequest(
          postUrl,
          postBody,
          session,
          dispatch,
          res => {
            callback({ success: 1 });
          },
          error => {
            callback({ success: 0, message: error });
          }
        );
      };

    case 'dislike':
      let delUrl = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa_likes/${values}`;
      return dispatch => {
        deleteRequest(
          delUrl,
          session,
          dispatch,
          res => {
            callback({ success: 1 });
          },
          error => {
            callback({ success: 0, message: error });
          }
        );
      };

    default:
      break;
  }
};

export const liveQAPinPublish = (session, qaid, value, callback) => {
  var filter = encodeURI(`(eventid=${session.eventid})AND(qaid=${qaid})`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa?filter=(${filter})`;
  let patchBody = {
    resource: [{ ...value }]
  };

  return dispatch => {
    patchRequest(
      url,
      patchBody,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const deleteLiveQA = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/liveqa`;
  let postBody = {
    requesttype: 'delete',
    sessionid: data.sessionid,
    qaid: data.qaid,
    userid: session.userid
  };

  return dispatch => {
    postRequest(
      url,
      postBody,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchSessionPolls = (session, sessionid, activeType, callback) => {
  let url = `${INSTANCE_URL}/api/v2/liveqa`;
  let postBody = {
    requesttype: 'fetchpoll',
    sessionid: sessionid,
    isactive: activeType,
    userid: session.userid
  };

  return dispatch => {
    postRequest(
      url,
      postBody,
      session,
      dispatch,
      res => {
        // console.log('res: ', res);
        // correct res format
        // totalcount: 4, publishedcount: '1', unpublishedcount: '3', notsubmittedpoll: 0, data: Array(1)
        let obj = {
          totalcount: res.resource.totalcount,
          publishedcount: JSON.parse(res.resource.publishedcount),
          unpublishedcount: JSON.parse(res.resource.unpublishedcount),
          notsubmittedpoll: res.resource.notsubmittedpoll,
          data: res.resource.data
        };
        dispatch({
          type: SESSION_POLL_LIST,
          payload: {
            data: res.resource.data,
            count: res.resource.totalcount,
            fetchData: obj
          }
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchNotSubmittedPollCounts = (session, sessionid, callback) => {
  let url = `${INSTANCE_URL}/api/v2/liveqa`;
  let postBody = {
    requesttype: 'notsubmittedpoll',
    sessionid: sessionid,
    userid: session.userid
  };

  return dispatch => {
    postRequest(
      url,
      postBody,
      session,
      dispatch,
      res => {
        // console.log('res: ', res);
        // correct res format
        // totalcount: 4, publishedcount: '1', unpublishedcount: '3', notsubmittedpoll: 0, data: Array(1)
        let obj = {
          totalcount: res.resource.totalcount,
          publishedcount: JSON.parse(res.resource.publishedcount),
          unpublishedcount: JSON.parse(res.resource.unpublishedcount),
          notsubmittedpoll: res.resource.notsubmittedpoll
        };
        dispatch({
          type: SESSION_POLL_NOT_SUBMITTED,
          payload: {
            data: res.resource.data,
            count: res.resource.notsubmittedpoll,
            fetchData: obj
          }
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const clearNotSubmittedPollCounts = () => {
  return dispatch =>
    dispatch({
      type: SESSION_POLL_NOT_SUBMITTED,
      payload: { count: 0 }
    });
};

export const clearSessionPolls = () => {
  return dispatch => {
    dispatch({
      type: SESSION_POLL_LIST,
      payload: {}
    });
  };
};

export const pollListModal = obj => {
  return dispatch => {
    dispatch({ type: SESSION_POLL_LIST_MODAL, payload: obj });
  };
};

export const pollActionModal = obj => {
  return dispatch => {
    dispatch({ type: SESSION_POLL_ACTION_MODAL, payload: obj });
  };
};

export const savePollAns = (session, values, callback) => {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/poll_results`;
  var body = { resource: values };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // callback({ success: 1 });
        dispatch(pollResult(session, values.pollid, callback));
        dispatch(singlePoll(session, values.pollid, callback));
      },
      error => {
        // callback({ success: 0, message: error });
      }
    );
  };
};

export const pollResult = (session, pollid, callback) => {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  var body = { type: 'pollResult', pollid: pollid, eventid: session.eventid };

  return dispatch => {
    dispatch({
      type: SESSION_POLL_RESULT,
      payload: {}
    });
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        dispatch({
          type: SESSION_POLL_RESULT,
          payload: response
        });
        callback({ success: 1, resource: response });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const singlePoll = (session, pollid, callback) => {
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(pollid=${pollid})AND(isarchived=0)`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/poll_questions?include_count=true&related=poll_results_by_pollid&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        // console.log('data:- ', data);
        dispatch(
          pollActionModal({
            showModal: true,
            modalData: data?.resource.length > 0 ? data.resource[0] : []
          })
        );
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const makeEmpty_pollResult = () => {
  return dispatch => {
    dispatch({
      type: SESSION_POLL_RESULT,
      payload: {}
    });
  };
};

export const addLiveQaPoll = (session, resourceObj, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/poll_questions`;
  let postBody = {
    resource: [{ ...resourceObj }]
  };

  return dispatch => {
    postRequest(
      url,
      postBody,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchBookedSchedule = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(type=schedule)`
  );
  // var url = `${INSTANCE_URL}/api/v2/eventify/_table/bookmarks?include_count=true&fields=bookmarkid,typeid&filter=(${filter})`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/bookmarks?include_count=true&filter=(${filter})`;

  return dispatch => {
    dispatch({
      type: MY_BOOKED_SCHEDULE,
      payload: {}
    });
    getRequest(
      url,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        dispatch({
          type: MY_BOOKED_SCHEDULE,
          payload: { resource: response.resource, count: response.meta.count }
        });
        callback({
          success: 1,
          resource: response.resource,
          count: response.meta.count
        });
      },
      error => {
        // callback({ success: 0, message: error });
      }
    );
  };
};

export const saveMySchedule = (session, values, callback) => {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/bookmarks`;
  var body = {
    resource: values
  };
  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const deleteMySchedule = (session, bookmarkId, typeId, callback) => {
  let delFilter = typeId ? encodeURI(`typeid=${typeId}`) : '';
  let bookIdUrlExt = bookmarkId ? `/${bookmarkId}` : '';

  let delUrl = `${INSTANCE_URL}/api/v2/eventify/_table/bookmarks${bookIdUrlExt}${
    !_.isEmpty(delFilter) ? `?filter=(${delFilter})` : ``
  }`;

  return dispatch => {
    deleteRequest(
      delUrl,
      session,
      dispatch,
      response => {
        fetchBookedSchedule(session, res => {});
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const storeSessionRatings = (session, values, callback) => {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sessionratings`;
  var body = {
    resource: [{ ...values }]
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
        dispatch(fetchRatedSessions(session, res => {}));
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchRatedSessions = (session, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sessionratings?include_count=true&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        dispatch({
          type: MY_RATED_SESSION,
          payload: { resource: response.resource, count: response.meta.count }
        });
        callback({
          success: 1,
          resource: response.resource,
          count: response.meta.count
        });
      },
      error => {
        // callback({ success: 0, message: error });
      }
    );
  };
};

export const holdThisSessionDetails = obj => {
  return dispatch => {
    dispatch({
      type: HOLD_THIS_SESSION_DETAILS,
      payload: obj
    });
  };
};

export const setSessionVideoModalDetails = obj => {
  return dispatch => {
    dispatch({ type: SESSION_VIDEO_MODAL_DETAILS, payload: obj });
  };
};

export const fetchSessionSpeakers = (session, sessid, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(sessionid=${sessid})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/session?related=speaker_by_speakerid,speaker_by_sessionspeakers&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        if (!_.isEmpty(res.resource[0]?.speaker_by_speakerid)) {
          res.resource[0].speaker_by_sessionspeakers.splice(
            0,
            0,
            res.resource[0].speaker_by_speakerid
          );
        }
        callback({
          success: 1,
          data: res.resource[0]?.speaker_by_sessionspeakers,
          count: res.resource[0]?.speaker_by_sessionspeakers.length
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchSessionRatingForm = (session, value, callback) => {
  let filter = encodeURI(
      `(eventid=${session.eventid})AND(sessionid=${value.sessionid})`
    ),
    related = 'event_forms_by_sessionratingid',
    getUrl = `${INSTANCE_URL}/api/v2/eventify/_table/session?related=${related}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      getUrl,
      session,
      dispatch,
      res => {
        dispatch({
          type: THIS_SESSION_RATING_FORM,
          payload: { data: res.resource, count: res.meta.count }
        });
        callback({
          success: 1,
          data: { data: res.resource, count: res.meta.count }
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchSessionsByTags = (session, tag, callback) => {
  let fetchFilter = encodeURI(
    `(eventid=${session.eventid})AND(tags CONTAINS ${tag})`
  );
  let fetchOrderby = 'starttime%20ASC,sessionid%20ASC';
  let fetchRelated =
    'speaker_by_speakerid,speaker_by_sessionspeakers,interactivemaps_by_interactivemaplocation_session_link,scheduletracks_by_scheduletrackid';
  let fetchUrl = `${INSTANCE_URL}/api/v2/eventify/_table/session?include_count=true&related=${fetchRelated}&order=${fetchOrderby}&filter=(${fetchFilter})`;

  return dispatch => {
    dispatch({
      type: SESSION_BY_TAG_FILTERED,
      payload: {}
    });
    getRequest(
      fetchUrl,
      session,
      dispatch,
      data => {
        _.map(data.resource, item => {
          if (!_.isEmpty(item.speaker_by_speakerid)) {
            item.speaker_by_sessionspeakers.splice(
              0,
              0,
              item.speaker_by_speakerid
            );
          }
        });
        dispatch({
          type: SESSION_BY_TAG_FILTERED,
          payload: { data: data.resource, count: data.meta.count }
        });
        callback({
          success: 1,
          result: { response: data.resource }
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchSessionColors = (session, callback) => {
  let fetchUrl = `${INSTANCE_URL}/api/v2/eventify/_table/sessioncolors?include_count=true`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        let payloadObj = {
          data: res.resource,
          count: res.meta.count
        };
        dispatch({ type: SESSION_COLORS, payload: payloadObj });
        callback({ ...payloadObj, success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};
